//Get the scrollbar width
let r = document.querySelector(':root');
let scrollbarWidth = (window.innerWidth - document.body.clientWidth) + 'px';

r.style.setProperty('--scrollbar-width', scrollbarWidth);

// Menu trigger
let header = document.querySelector('#site-header');
let navContainer = document.querySelector('.site-menu-overlay');
let resetTabOrderEl = navContainer.querySelector('.arc-logo');
let hamburgerIcon = document.querySelector('#site-header .hamburger');
let scrollLock = 0,
	menuOpen = 0;

//Loop tab order in menu
resetTabOrderEl.addEventListener('blur', (event) => {
	navContainer.querySelector(".logo").classList.add('focused');
	// navContainer.querySelector(".logo").focus();
	hamburgerIcon.focus();
});


hamburgerIcon.addEventListener('blur', (event) => {
	if (menuOpen == 1) { // avoid tabbing to header items when menu is open;
		navContainer.querySelector(".logo").focus();
	}
});


hamburgerIcon.addEventListener('click', function () {
	hamburgerIcon.classList.toggle('active');

	if (!scrollLock) {
		openMenu();
		bodyScrollLock.disableBodyScroll(navContainer, {
			reserveScrollBarGap: true
		});
		scrollLock = 1;
	}
	else {
		closeMenu();

	}
});

// Ways to close the menu. Click outside of it, or press Escape key
navContainer.addEventListener('click', function (e) {
	if (e.target == e.currentTarget) {
		closeMenu();
	}
});

navContainer.addEventListener('keyup', function(e) {
	if (e.key == "Escape") {
		closeMenu();
		hamburgerIcon.focus();
	}
});


function closeMenu() {
	menuOpen = 0;
	r.style.setProperty('--scrollbar-width', '0px');
	hamburgerIcon.classList.remove('active');
	hamburgerIcon.setAttribute('aria-expanded', false);
	hamburgerIcon.setAttribute('aria-label', "open menu");

	header.classList.remove('menu-active');
	navContainer.setAttribute('aria-hidden', true);
	navContainer.querySelector(".logo").classList.remove('focused'); // prevent focus outline displaying on logo again when menu re-opened

	bodyScrollLock.enableBodyScroll(navContainer);
	scrollLock = 0;
}

function openMenu() {
	menuOpen = 1;
	r.style.setProperty('--scrollbar-width', scrollbarWidth);
	hamburgerIcon.setAttribute('aria-expanded', true);
	hamburgerIcon.setAttribute('aria-label', "close menu");

	header.querySelector("ul li:nth-child(3)").setAttribute('tabindex', "-1");

	header.classList.add('menu-active');
	navContainer.setAttribute('aria-hidden', false);
	navContainer.querySelector(".logo").focus(); // focus on first link in nav for tab order to work correctly

	bodyScrollLock.disableBodyScroll(navContainer, {
		reserveScrollBarGap: true
	});
	scrollLock = 1;

}


// Get scroll Y of element
function getOffset(el) {
	const rect = el.getBoundingClientRect();
	return {
		left: rect.left + window.scrollX,
		top: rect.top + window.scrollY
	};
}

const afterHero = document.querySelector("main.primary > section:nth-child(1)"); // First section after hero
let navOffset = 0

if (afterHero) {
	navOffset = (getOffset(afterHero).top);
}

function homeHeaderScroll() {
	if (document.body.scrollTop > navOffset || document.documentElement.scrollTop > navOffset) {
		header.classList.add('visible');
	} else {
		header.classList.remove('visible');
	}
}

if (document.querySelector('.page-home')) {
	window.addEventListener("scroll", homeHeaderScroll);
}

// Prevent anchor tags from showing in URL
let anchorLinks = document.querySelectorAll("a[href^=\'#\'] ");

anchorLinks.forEach(anchor => {
	anchor.addEventListener("click", function(event){
		setTimeout(() => {
			history.replaceState(null, null, ' ');
		}, 5);
	});
});
